import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { Header } from "@/components/Header";

const GAMES = [
  { id: "astro-swarm", title: "Astro Swarm", tag: "Arcade Shooter" },
  { id: "terra-forge", title: "Terra Forge", tag: "Colony Builder" },
];

const GamePicker = ({ active, onPick }) => (
  <div className="flex items-center gap-2 overflow-x-auto hide-scrollbar border-b border-white/10 px-4 py-2" data-testid="game-picker">
    <span className="mr-2 shrink-0 font-mono text-[10px] uppercase tracking-[0.25em] text-amber">Arcade</span>
    {GAMES.map((g) => (
      <button
        key={g.id}
        type="button"
        data-testid={`game-tab-${g.id}`}
        onClick={() => onPick(g.id)}
        className={`shrink-0 rounded-full border px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.15em] transition-colors duration-300 ${
          active.id === g.id ? "border-amber bg-amber text-black" : "border-white/15 text-white/70 hover:border-amber hover:text-amber"
        }`}
      >
        {g.title} <span className={active.id === g.id ? "text-black/60" : "text-white/35"}>· {g.tag}</span>
      </button>
    ))}
  </div>
);

export default function Games() {
  const [params, setParams] = useSearchParams();
  const game = GAMES.find((g) => g.id === params.get("g")) || GAMES[0];
  const pick = (id) => {
    const next = new URLSearchParams(params);
    next.set("g", id);
    setParams(next, { replace: true });
  };

  return (
    <div className="flex h-[100dvh] flex-col bg-[#050505]" data-testid="games-page">
      <Helmet>
        <title>{`${game.title} · ReelVault Arcade`}</title>
        <meta name="description" content="Play free browser games on ReelVault between movies." />
      </Helmet>
      <Header />
      <GamePicker active={game} onPick={pick} />
      <iframe
        key={game.id}
        data-testid="games-iframe"
        src={`/arcade/${game.id}/index.html`}
        title={game.title}
        allow="fullscreen; autoplay; gamepad"
        tabIndex={0}
        className="rv-gpu w-full flex-1 border-none bg-black"
      />
    </div>
  );
}
